<twc-switch [selectedIndex]="selectedIndex" twcTooltip="{{property.label + '_TOOLTIP' | translate}}"
    (selectionChanged)="saveSelectedOption($event)">
    <twc-switch-button [data]="{type:false}">{{property.label + '_1' | translate}}</twc-switch-button>
    <twc-switch-button [data]="{type:true}">{{property.label + '_2' | translate}}</twc-switch-button>
</twc-switch>